module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.erikson.edu",
    "title": "Erikson Institute",
    "tfn": "",
    "url": "https://info.erikson.edu",
    "gtm_code": "GTM-PM2PS6Q6",
}